import { COLORS, SPACE } from './tokens'
import './insuranceReviewPrint.css'
import EmptyState from './EmptyState'
import RightRail from './RightRail'
import TheTake from './sections/TheTake'
import CoverageStructure from './sections/CoverageStructure'
import CoverageAdequacy from './sections/CoverageAdequacy'
import CoverageGaps from './sections/CoverageGaps'
import BrokerConversation from './sections/BrokerConversation'
import SpecialistUncertainty from './sections/SpecialistUncertainty'
import useFindingDisposition from './useFindingDisposition'
import useVerifyReview from './useVerifyReview'
import useRunNewReview from './useRunNewReview'
import { classifyRisk } from './hallucinationRisk'
import NeedsReviewSection from './NeedsReviewSection'
import VerifyDeliverPanel from './VerifyDeliverPanel'
import ExportPdfButton from './ExportPdfButton'
import RunNewReviewButton from './RunNewReviewButton'

export default function CurrentReviewView({ term, review, findings, sourceDocuments, onRunNewReview, onReviewRefetch }) {
  const disposition = useFindingDisposition({ findings, onChanged: onReviewRefetch })

  // Derive risk map for every finding
  const riskMap = {}
  for (const f of findings || []) {
    riskMap[f.id] = classifyRisk(f)
  }

  const verifyHook = useVerifyReview({
    reviewId: review?.id,
    onVerified: onReviewRefetch,
    onDelivered: onReviewRefetch
  })

  const runNew = useRunNewReview({
    clientId: review?.client_id,
    currentReview: review,
    currentTerm: term,
    onStarted: onRunNewReview
  })

  if (!review) return <EmptyState reason="no-review" />

  const locked = review.review_state !== 'draft'

  return (
    <div
      data-print="content"
      style={{
        background: COLORS.bodyBg,
        color: COLORS.bodyText,
        padding: `48px 64px`,
        minHeight: '100%'
      }}
    >
      <div style={{ display: 'flex', gap: '48px', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: SPACE.sectionGap }}>
          <NeedsReviewSection findings={findings} riskMap={riskMap} dispositionMap={disposition.dispositionMap} locked={locked} />
          <TheTake review={review} findings={findings} />
          <CoverageStructure term={term} review={review} />
          <CoverageAdequacy review={review} />
          <CoverageGaps
            findings={findings}
            riskMap={riskMap}
            dispositionMap={disposition.dispositionMap}
            onSetDisposition={disposition.setDisposition}
            onSetEdits={disposition.setEdits}
            locked={locked}
          />
          <BrokerConversation findings={findings} />
          <SpecialistUncertainty findings={findings} />
        </div>
        <div data-print="hide">
          <RightRail
            findings={findings}
            sourceDocuments={sourceDocuments}
            checkedIds={new Set()}
            onToggle={() => {}}
            verifyPanel={
              <VerifyDeliverPanel
                review={review}
                allDispositioned={disposition.allDispositioned(riskMap)}
                verifying={verifyHook.verifying}
                delivering={verifyHook.delivering}
                error={verifyHook.error}
                onVerify={verifyHook.verify}
                onDeliver={verifyHook.deliver}
              />
            }
            actions={
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                <ExportPdfButton />
                <RunNewReviewButton
                  isOpen={runNew.isOpen}
                  submitting={runNew.submitting}
                  onOpen={runNew.open}
                  onClose={runNew.close}
                  onSubmit={runNew.submit}
                />
              </div>
            }
          />
        </div>
      </div>
    </div>
  )
}
